module.exports = function getResource(label, vars = []) {
    const resources = {
        search: 'Search',
        cancel: 'Cancel',
        previousSearches: 'Previous Searches',
        clearInputAriaLabel: 'clear search input text',
        searchSuggestions: 'Search Suggestions',
        productSuggestions: 'Product Suggestions'
    };

    return resources[label];
};
